<template>
  <b-sidebar
    v-if="sidebarWidth !== ''"
    id="pik-yug-price-sidebar"
    bg-variant="white"
    right
    lazy
    backdrop
    no-close-on-backdrop
    no-header
    @shown="getData"
    @hidden="resetSidebarData"
    shadow
    :width="sidebarWidth"
    ref="pikYugPriceSidebar"
    :title="addPrice ? 'Добавление прайса Пик-Юг' : 'Редактирование прайса Пик-Юг'">
    <template v-slot:default="{ hide }">
      <b-container fluid>
        <b-button-close @click="hide()"></b-button-close>
        <b-form @submit.stop.prevent="saveFormData" autocomplete="off">
          <h2 v-if="addPrice" class="my-4">Добавление прайса Пик-Юг</h2>
          <h2 v-else class="my-4">Редактирование прайса Пик-Юг</h2>
          <b-row>
            <b-col>
              <b-form-group
                label="Месяц начала действия прайса"
                label-for="dateStart"
                label-class="mf-label"
                class="my-3">
                <a-month-picker
                  class="mr-3"
                  size="large"
                  v-model="dateStart"
                  :disabled="disabled"
                  format="MM/YYYY"
                  placeholder="Дата"/>
              </b-form-group>
            </b-col>
          </b-row>
          <h4 class="form-title">Пакеты</h4>
          <b-row>
            <b-col xl="5">
              <b-table
                id="data_table"
                ref="pricePikYug"
                hover
                :fields="fields"
                :items="modelPrice"
              >
                <template v-slot:cell(packageName)="data">
                  <b>{{ data.item.packageName }}</b>
                </template>
                <template v-slot:cell(priceDefault)="">
                  <b-form-group
                    :invalid-feedback="getError('Стоимость')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="priceDefault0-input"
                      name="Стоимость"
                      v-validate="priceValidation"
                      data-vv-as="Стоимость"
                      v-model="modelPrice[0].priceDefault"
                      :disabled="disabled"
                      :state="validateState('Стоимость')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(priceRecalc)="">
                  <b-form-group
                    :invalid-feedback="getError('Вознаграждение')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="priceRecalc0-input"
                      name="Вознаграждение"
                      v-validate="priceValidation"
                      data-vv-as="Вознаграждение"
                      v-model="modelPrice[0].priceRecalc"
                      :disabled="disabled"
                      :state="validateState('Вознаграждение')"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <h4 class="form-title">Вознаграждение</h4>
          <b-row>
            <b-col xl="3">
              <b-table
                id="data_table"
                hover
                ref="compensation"
                :fields="compensationFields"
                :items="compensationModel"
              >
                <template v-slot:cell(type)="data">
                  <b>{{ data.item.type }}</b>
                </template>
                <template v-slot:cell(percent)="data">
                  <b-form-group
                    v-if="data.item.type === 'Пакеты'"
                    :invalid-feedback="getError('Пакеты')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="percentPackages-input"
                      name="Пакеты"
                      v-validate="priceValidation"
                      data-vv-as="Пакеты"
                      v-model="compensationModel[0].percentPackages"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Пакеты')"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
            <b-col class="d-flex align-items-end mb-6">
              <b-button :disabled="disabled" @click="recalcPrices" variant="outline-primary" v-b-tooltip title="Рассчитать" class="ml-4"><i class="fas fa-calculator"></i></b-button>
            </b-col>
          </b-row>
          <b-row class="mb-3 mt-3">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12">
              <div class="d-md-flex d-lg-flex align-items-start">
                <b-button
                  :disabled="veeErrors.any() || (Boolean(dateStart) === false) || disabled"
                  variant="success"
                  type="submit"
                  class="btn-action-success mr-3 mb-2">
                  <span v-if="addPrice">Добавить прайс</span>
                  <span v-else>Изменить прайс</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </template>
  </b-sidebar>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { validation } from '../modalForms/validation'
import moment from 'moment'

export default {
  name: 'AddPikYugPrice',
  components: {},
  props: ['addPrice', 'startMonth', 'startYear', 'disabled'],
  mixins: [validation],
  data () {
    return {
      billingAlias: 'dyn_pu',
      sidebarWidth: '',
      dateStart: null,
      fields: [
        { key: 'packageName', label: 'Наименование' },
        { key: 'priceDefault', label: 'Стоимость' },
        { key: 'priceRecalc', label: 'Вознаграждение' }
      ],
      modelPrice: [
        { packageName: 'Передача пакета документов', priceDefault: null, priceRecalc: null }
      ],
      compensationFields: [
        { key: 'type', label: 'Тип' },
        { key: 'percent', label: 'Процент' }
      ],
      compensationModel: [
        { type: 'Пакеты', percentPackages: null }
      ],
      oldStartMonth: null,
      oldStartYear: null
    }
  },
  mounted () {
    this.calcSidebarWidth()
  },
  computed: {
    ...mapState(
      {
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop,
        dealerPriceData: state => state.dealers.dealerPriceData
      }
    )
  },
  methods: {
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    getData () {
      if (!this.addPrice) {
        this.getDealerPrice({ month: this.startMonth, year: this.startYear, id: this.$route.params.id, billing_alias: this.billingAlias }).then(
          () => {
            console.log(this.dealerPriceData)
            this.modelPrice[0].priceDefault = this.dealerPriceData.packages[0].client_points_cost
            this.modelPrice[0].priceRecalc = this.dealerPriceData.packages[0].daobit_points_cost
            this.compensationModel[0].percentPackages = parseFloat((this.dealerPriceData.packages[0].daobit_points_cost * 100 / this.dealerPriceData.packages[0].client_points_cost).toFixed(2))
            const dt = this.startYear + '-' + (this.startMonth.length > 0 ? this.startMonth : ('0' + this.startMonth)) + '-' + '01'
            this.dateStart = moment(dt)
            this.oldStartMonth = this.startMonth
            this.oldStartYear = this.startYear
          }
        )
      } else {
        this.dateStart = null
      }
    },
    percentage (percent, total) {
      return ((percent / 100) * total).toFixed(2)
    },
    recalcPrices () {
      this.modelPrice[0].priceRecalc = parseFloat(this.percentage(this.compensationModel[0].percentPackages, this.modelPrice[0].priceDefault))
    },
    calcSidebarWidth () {
      if (this.largeDesktop) {
        this.sidebarWidth = '50%'
      } else if (this.desktop) {
        this.sidebarWidth = '100%'
      } else if (this.mobile || this.tablet) {
        this.sidebarWidth = '100%'
      }
    },
    saveFormData () {
      const data = {
        year: null,
        month: null,
        year_new: null,
        month_new: null,
        // percent_lycense: this.compensationModel[1].percentLicense ? parseFloat(this.compensationModel[1].percentLicense) : null,
        // percent_packages: this.compensationModel[0].percentPackages ? parseFloat(this.compensationModel[0].percentPackages) : null,
        packages: [
          {
            message_price_position_alias: 'pp_pnp_pu',
            client_points_cost: parseFloat(this.modelPrice[0].priceDefault),
            daobit_points_cost: this.modelPrice[0].priceRecalc
          },
          {
            message_price_position_alias: 'pp_pds_pu',
            client_points_cost: parseFloat(this.modelPrice[0].priceDefault),
            daobit_points_cost: this.modelPrice[0].priceRecalc
          },
          {
            message_price_position_alias: 'pp_pi_pu',
            client_points_cost: parseFloat(this.modelPrice[0].priceDefault),
            daobit_points_cost: this.modelPrice[0].priceRecalc
          },
          {
            message_price_position_alias: 'pp_pit_pu',
            client_points_cost: parseFloat(this.modelPrice[0].priceDefault),
            daobit_points_cost: this.modelPrice[0].priceRecalc
          },
          {
            message_price_position_alias: 'pp_svh_pu',
            client_points_cost: parseFloat(this.modelPrice[0].priceDefault),
            daobit_points_cost: this.modelPrice[0].priceRecalc
          },
          {
            message_price_position_alias: 'pp_departure_pu',
            client_points_cost: parseFloat(this.modelPrice[0].priceDefault),
            daobit_points_cost: this.modelPrice[0].priceRecalc
          }
        ]
      }

      const year = this.dateStart.toDate().getFullYear()
      const month = this.dateStart.toDate().getMonth() + 1

      if (this.addPrice) {
        data.year = year
        data.month = month
      } else {
        data.year_new = year
        data.month_new = month
        data.year = this.oldStartYear
        data.month = this.oldStartMonth
      }

      if (this.addPrice) {
        this.saveDealerPrice({ data: data, billing_alias: this.billingAlias, id: this.$route.params.id }).then(
          (response) => {
            console.log('response ', response)
            this.getDealerPricesData({ id: this.$route.params.id })
            this.$refs.pikYugPriceSidebar.hide()
          }
        )
      } else {
        this.updateDealerPrice({ data: data, billing_alias: this.billingAlias, id: this.$route.params.id }).then(
          () => {
            this.getDealerPricesData({ id: this.$route.params.id })
            this.$refs.pikYugPriceSidebar.hide()
          }
        )
      }
    },
    resetSidebarData () {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
      setTimeout(() => {
        this.modelPrice[0].priceDefault = null
        this.modelPrice[0].priceRecalc = null
        this.compensationModel[0].percentPackages = null
        this.setPrice(null)
      }, 200)
    },
    ...mapActions('dealers', [
      'saveDealerPrice',
      'getDealerPrice',
      'updateDealerPrice',
      'getDealerPricesData'
    ]),
    ...mapMutations('dealers', [
      'setPrice'
    ])
  }
}
</script>

<style scoped>

</style>
